import { Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";

import { HeaderWithBack } from "components/HeaderBack";
import { setStep } from "store/features/registration/slice";
import { useEffect } from "react";
import styles from "./styles.module.scss";

export default function SingleLayout() {
	const location = useLocation();
	const dispatch = useDispatch();

	const steps = [
		{ number: 1, label: "Perfil" },
		{ number: 2, label: "Veículos" },
		{ number: 3, label: "Motoristas" },
		{ number: 4, label: "Financeiro" }
	];

	const routeStepMap: Record<string, number> = {
		"/cadastro/informacoes-pessoais": 1,
		"/cadastro/veiculos": 2,
		"/cadastro/motoristas": 3,
		"/cadastro/contas": 4
	};

	const currentStep = useSelector(
		(state: RootState) => state.registration.step
	);

	useEffect(() => {
		const step = routeStepMap[location.pathname];
		if (step) {
			dispatch(setStep(step));
		}
	}, [location.pathname, dispatch]);

	return (
		<div className={styles.container}>
			<HeaderWithBack label="Crie a sua conta" backTo={-1} />
			<div className={styles.stepsContainer}>
				{steps.map((step, index) => (
					<div key={step.number} className={styles.steps}>
						<div className={styles.stepsContent}>
							<div
								className={`${styles.stepNumber} ${
									step.number === currentStep ? styles.active : styles.inactive
								}`}
							>
								{step.number}
							</div>
							<div className={styles.stepLabel}>{step.label}</div>
						</div>
						{index < steps.length - 1 && (
							<div className={styles.stepsDivider} />
						)}
					</div>
				))}
			</div>
			<Outlet />
		</div>
	);
}
